export const getErrorMessageFromError = (err) => {
  return err.response && err.response.data ? err.response.data.title ? err.response.data.title
    : typeof err.response.data === 'string' ? err.response.data : err.response.data.message : err.message;
}
